import { Link } from "react-router-dom";
import { ArrowRight, Phone, Sparkles, DollarSign, UserCheck, FileText, ShieldCheck, Users } from "lucide-react";

const FLYER_IMAGE = "https://customer-assets.emergentagent.com/job_small-biz-insurance/artifacts/1w4am085_6C155F60-A04A-4D0F-9A5C-8F4A5B373F3C.PNG";

const offerHighlights = [
  { icon: DollarSign, label: "$2 per employee / month" },
  { icon: UserCheck, label: "Employer paid" },
  { icon: FileText, label: "No census required" },
  { icon: ShieldCheck, label: "2 year rate guarantee" },
  { icon: Users, label: "10+ eligible employees" },
];

const VoluntaryStat = ({ value, label, bordered }) => (
  <div className={bordered ? "border-x border-white/10" : ""}>
    <div className="font-bold text-2xl text-white" style={{ fontFamily: "'Outfit', sans-serif" }}>{value}</div>
    <div className="text-gray-400 text-xs uppercase tracking-wide mt-1">{label}</div>
  </div>
);

const HighlightItem = ({ icon: Icon, label }) => (
  <li className="flex items-center space-x-3">
    <div className="w-9 h-9 bg-[#2EC4C4]/15 border border-[#2EC4C4]/30 rounded-lg flex items-center justify-center flex-shrink-0">
      <Icon size={18} className="text-[#2EC4C4]" />
    </div>
    <span className="text-white font-medium">{label}</span>
  </li>
);

export const LimitedTimeOfferSection = () => (
  <section data-testid="limited-time-offer-section" className="py-20 bg-gradient-to-br from-[#0F1B33] via-[#1A2744] to-[#0F1B33] relative overflow-hidden">
    <div className="absolute top-0 right-0 w-96 h-96 bg-[#2EC4C4] opacity-10 rounded-full blur-3xl pointer-events-none" />
    <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#2EC4C4] opacity-10 rounded-full blur-3xl pointer-events-none" />

    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center">
        <div data-testid="offer-content" className="text-white">
          <div className="inline-flex items-center space-x-2 bg-[#2EC4C4]/15 border border-[#2EC4C4]/40 text-[#2EC4C4] font-semibold text-xs sm:text-sm uppercase tracking-wider px-4 py-2 rounded-full mb-6">
            <Sparkles size={14} />
            <span>Limited Time Offer</span>
          </div>
          <h2 className="font-bold text-4xl sm:text-5xl text-white mb-3 leading-tight" style={{ fontFamily: "'Outfit', sans-serif" }}>
            $10,000 Group Term <span className="text-[#2EC4C4]">Life Insurance</span>
          </h2>
          <p className="text-gray-300 text-lg mb-8 leading-relaxed">
            Help protect your employees and their families at no cost to them. Affordable, simple, and valuable coverage that shows you care.
          </p>

          <ul className="space-y-3 mb-8">
            {offerHighlights.map((h) => <HighlightItem key={h.label} icon={h.icon} label={h.label} />)}
          </ul>

          <div className="bg-white/5 border border-white/10 rounded-xl p-5 mb-8">
            <p className="text-[#2EC4C4] font-semibold text-xs uppercase tracking-wider mb-3">Additional Voluntary Coverage Available</p>
            <div className="grid grid-cols-3 gap-3 text-center">
              <VoluntaryStat value="$75K" label="Employee" />
              <VoluntaryStat value="$25K" label="Spouse" bordered />
              <VoluntaryStat value="$10K" label="Child" />
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-3">
            <Link to="/contact" data-testid="claim-offer-btn" className="inline-flex items-center justify-center space-x-2 bg-[#2EC4C4] hover:bg-[#25A0A0] text-white font-semibold rounded-lg px-8 py-4 text-base transition-all shadow-md hover:shadow-lg active:scale-95">
              <span>Claim This Offer</span><ArrowRight size={18} />
            </Link>
            <a href="tel:+17017217993" data-testid="claim-offer-call-btn" className="inline-flex items-center justify-center space-x-2 bg-transparent border-2 border-white/30 text-white hover:bg-white/10 font-semibold rounded-lg px-8 py-4 text-base transition-all">
              <Phone size={18} /><span>(701) 721-7993</span>
            </a>
          </div>
          <p className="text-gray-400 text-xs mt-5">In partnership with Colonial Life</p>
        </div>

        <div data-testid="offer-flyer" className="relative">
          <div className="absolute -inset-4 bg-[#2EC4C4]/20 rounded-3xl blur-2xl pointer-events-none" />
          <img
            src={FLYER_IMAGE}
            alt="$10,000 Group Term Life Insurance limited time offer flyer"
            className="relative w-full max-w-md mx-auto rounded-2xl shadow-2xl ring-1 ring-white/10"
            loading="lazy"
          />
        </div>
      </div>
    </div>
  </section>
);
